import { render, staticRenderFns } from "./CanaryMarker.vue?vue&type=template&id=700f2076&scoped=true"
import script from "./CanaryMarker.vue?vue&type=script&setup=true&lang=ts"
export * from "./CanaryMarker.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CanaryMarker.vue?vue&type=style&index=0&id=700f2076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700f2076",
  null
  
)

export default component.exports